var map = {
	"./1960-minutes-to-go/1960MinutesToGo": 99,
	"./1960-minutes-to-go/1960MinutesToGo.json": 99,
	"./1960-minutes-to-go/images/calling-all-reactive-agents-1.jpg": 219,
	"./1960-minutes-to-go/images/calling-all-reactive-agents-2.jpg": 220,
	"./1960-minutes-to-go/images/calling-all-reactive-agents-3.jpg": 221,
	"./1960-minutes-to-go/images/i-think-therefore-i-am.jpg": 222,
	"./1960-minutes-to-go/images/rub-out-the-write-word.jpg": 223,
	"./1960-minutes-to-go/text/calling-all-reactive-agents.txt": 16,
	"./1960-minutes-to-go/text/i-think-therefore-i-am.txt": 29,
	"./1960-minutes-to-go/text/rub-out-the-write-word.txt": 55,
	"./1960-the-exterminator/images/can-mother-be-wrong.jpg": 224,
	"./1960-the-exterminator/images/in-the-beginning-was-the-word_1.jpg": 225,
	"./1960-the-exterminator/images/in-the-beginning-was-the-word_2.jpg": 226,
	"./1960-the-exterminator/images/junk-is-no-good-baby.jpg": 227,
	"./1960-the-exterminator/images/kick-that-habit-man.jpg": 228,
	"./1960-the-exterminator/images/proclaim-present-time-over.jpg": 229,
	"./1960-the-exterminator/images/rub-out-the-words.jpg": 230,
	"./1960-the-exterminator/images/short-time-to-go.jpg": 231,
	"./1960-the-exterminator/images/who-sends-the-man.jpg": 232,
	"./1960-the-exterminator/text/can-mother-be-wrong.txt": 57,
	"./1960-the-exterminator/text/in-the-beginning-was-the-word.txt": 58,
	"./1960-the-exterminator/text/junk-is-no-good-baby.txt": 18,
	"./1960-the-exterminator/text/kick-that-habit-man.txt": 17,
	"./1960-the-exterminator/text/proclaim-present-time-over.txt": 19,
	"./1960-the-exterminator/text/rub-out-the-words.txt": 59,
	"./1960-the-exterminator/text/short-time-to-go.txt": 30,
	"./1960-the-exterminator/text/who-sends-the-man.txt": 56,
	"./1961-bbc/text/calling-all-reactive-agents.txt": 63,
	"./1961-bbc/text/come-to-free-the-words.txt": 61,
	"./1961-bbc/text/i-am-that-i-am.txt": 64,
	"./1961-bbc/text/no-poets-dont-own-words.txt": 62,
	"./1961-bbc/text/pistol-poem.txt": 60,
	"./1967-anthology-of-concrete-poetry/1967AnthologyOfConcretePoetry": 100,
	"./1967-anthology-of-concrete-poetry/1967AnthologyOfConcretePoetry.json": 100,
	"./1967-anthology-of-concrete-poetry/images/i-am-that-i-am1.jpg": 233,
	"./1967-anthology-of-concrete-poetry/images/i-am-that-i-am2.jpg": 234,
	"./1967-anthology-of-concrete-poetry/text/i-am-that-i-am.txt": 94,
	"./1972-sam-francis-catalogue/text/this-is-sam-francis.txt": 33,
	"./1973-let-the-mice-in/1973LetTheMiceIn": 101,
	"./1973-let-the-mice-in/1973LetTheMiceIn.json": 101,
	"./1973-let-the-mice-in/images/copyright-notice.jpg": 235,
	"./1973-let-the-mice-in/images/iamthatiam1.jpg": 236,
	"./1973-let-the-mice-in/images/iamthatiam2.jpg": 237,
	"./1973-let-the-mice-in/images/iamthatiam3.jpg": 238,
	"./1973-let-the-mice-in/images/iamthatiam4.jpg": 239,
	"./1973-let-the-mice-in/images/iamthatiam5.jpg": 240,
	"./1973-let-the-mice-in/images/junk-is-no-good-baby.jpg": 241,
	"./1973-let-the-mice-in/images/kick-that-habit-man.jpg": 242,
	"./1973-let-the-mice-in/images/pistol-poem1.jpg": 243,
	"./1973-let-the-mice-in/images/pistol-poem2.jpg": 244,
	"./1973-let-the-mice-in/text/i-am-that-i-am.txt": 34,
	"./1973-let-the-mice-in/text/junk-is-no-good-baby.txt": 21,
	"./1973-let-the-mice-in/text/kick-that-habit-man.txt": 95,
	"./1973-let-the-mice-in/text/pistol-poem.txt": 96,
	"./1978-the-third-mind/1978TheThirdMind": 102,
	"./1978-the-third-mind/1978TheThirdMind.json": 102,
	"./1978-the-third-mind/images/breathe-in-the-words.jpg": 245,
	"./1978-the-third-mind/images/copyright-page.jpg": 246,
	"./1978-the-third-mind/images/i-am-that-i-am.jpg": 247,
	"./1978-the-third-mind/images/i-think-therefore-i-am.jpg": 248,
	"./1978-the-third-mind/images/junk-is-no-good-baby.jpg": 249,
	"./1978-the-third-mind/images/kick-that-habit-man.jpg": 250,
	"./1978-the-third-mind/images/permutations-intro.jpg": 251,
	"./1978-the-third-mind/images/pg84-85.jpg": 252,
	"./1978-the-third-mind/images/pistol-poem1.jpg": 253,
	"./1978-the-third-mind/images/present-time.jpg": 254,
	"./1978-the-third-mind/images/rub-out-the-word.jpg": 255,
	"./1978-the-third-mind/text/breathe-in-the-words.txt": 31,
	"./1978-the-third-mind/text/i-am-that-i-am.txt": 20,
	"./1978-the-third-mind/text/kick-that-habit-man.txt": 32,
	"./1978-the-third-mind/text/pistol-poem.txt": 92,
	"./1978-the-third-mind/text/rub-out-the-word.txt": 93,
	"./1981-songs/text/i-dont-work-you-dig.txt": 35,
	"./1982-orgy-boys/text/no-poets-dont-own-words.txt": 36,
	"./1986-british-library-tapes/C1400-1/i-am-that-i-am.txt": 65,
	"./1986-british-library-tapes/C1400-2/junk-is-no-good-baby.txt": 90,
	"./1986-british-library-tapes/C1400-2/kick-that-habit-man.txt": 91,
	"./1986-british-library-tapes/C1400-3/per-mu-ta-tions.txt": 66,
	"./1986-british-library-tapes/C1400-4/be-on-the-beat.txt": 81,
	"./1986-british-library-tapes/C1400-4/do-their-words-rub-out-there.txt": 75,
	"./1986-british-library-tapes/C1400-4/everyone-is-ahead-now.txt": 80,
	"./1986-british-library-tapes/C1400-4/got-some-part.txt": 88,
	"./1986-british-library-tapes/C1400-4/i-am-i-who-are-you.txt": 72,
	"./1986-british-library-tapes/C1400-4/i-am-out-are-you-in.txt": 85,
	"./1986-british-library-tapes/C1400-4/i-dig-you-man.txt": 83,
	"./1986-british-library-tapes/C1400-4/i-got-the-fear.txt": 79,
	"./1986-british-library-tapes/C1400-4/i-love-you-i-do.txt": 78,
	"./1986-british-library-tapes/C1400-4/in-the-beginning-was-the-word.txt": 67,
	"./1986-british-library-tapes/C1400-4/like-you-just-said.txt": 77,
	"./1986-british-library-tapes/C1400-4/lord-i-am-not-worthy.txt": 68,
	"./1986-british-library-tapes/C1400-4/play-it-cool-fool.txt": 71,
	"./1986-british-library-tapes/C1400-4/that-really-bugs-me.txt": 86,
	"./1986-british-library-tapes/C1400-4/this-could-be-you.txt": 73,
	"./1986-british-library-tapes/C1400-4/this-really-sends-me.txt": 70,
	"./1986-british-library-tapes/C1400-4/this-turns-me-on.txt": 84,
	"./1986-british-library-tapes/C1400-4/what-are-you-thinking.txt": 82,
	"./1986-british-library-tapes/C1400-4/what-words-to-steal.txt": 74,
	"./1986-british-library-tapes/C1400-4/what-you-not-got-in-there.txt": 87,
	"./1986-british-library-tapes/C1400-4/who-sends-the-man.txt": 69,
	"./1986-british-library-tapes/C1400-4/you-belong-to-me.txt": 76,
	"./1986-british-library-tapes/C1400-6/in-the-beginning-was-the-word.txt": 89,
	"./1996-mektoub/audio/01-ive-come-to-free-the-words.mp3": 256,
	"./1996-mektoub/audio/04-thoughts-on-the-bbc.mp3": 257,
	"./1996-mektoub/audio/05-i-am-that-i-am.mp3": 258,
	"./1996-mektoub/audio/06-pistol-poem.mp3": 259,
	"./1996-mektoub/audio/07-pistol-poem-pt2.mp3": 260,
	"./1996-mektoub/audio/08-recalling-all-active-agents.mp3": 261,
	"./1996-mektoub/audio/10-no-poets-dont-own-words.mp3": 262,
	"./1996-mektoub/audio/13-kick-that-habit-man.mp3": 263,
	"./1996-mektoub/audio/14-junk-is-no-good-baby.mp3": 264,
	"./2002-back-in-no-time/images/i-dont-work-you-dig.jpg": 265,
	"./2002-back-in-no-time/images/info.jpg": 266,
	"./2002-back-in-no-time/images/junk-is-no-good-baby.jpg": 267,
	"./2002-back-in-no-time/images/kick-that-habit-man.jpg": 268,
	"./2002-back-in-no-time/images/no-poets-dont-own-words1.jpg": 269,
	"./2002-back-in-no-time/images/no-poets-dont-own-words2.jpg": 270,
	"./2002-back-in-no-time/images/no-poets-dont-own-words3.jpg": 271,
	"./2002-back-in-no-time/images/no-poets-dont-own-words4.jpg": 272,
	"./2002-back-in-no-time/images/references.jpg": 273,
	"./2002-back-in-no-time/images/this-is-sam-francis.jpg": 274,
	"./2002-back-in-no-time/text/junk-is-no-good-baby.txt": 97,
	"./2002-back-in-no-time/text/kick-that-habit-man.txt": 98,
	"./databaseReference": 103,
	"./databaseReference.js": 103,
	"./not-yet-transcribed.txt": 10,
	"./poemDatabase": 11,
	"./poemDatabase.js": 11,
	"./poemDatabaseForBook": 104,
	"./poemDatabaseForBook.js": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;